import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import StoreManagement from './pages/StoreManagement';
import StoreDetail from './pages/StoreDetail';
import StoreSeatLayout from './pages/StoreSeatLayout';
import StorePhotoManagement from './pages/StorePhotoManagement';
import ReportManagement from './pages/ReportManagement';
import CustomerManagement from './pages/CustomerManagement';
import ReservationManagement from './pages/ReservationManagement';
import CouponManagement from './pages/CouponManagement';
import SystemManagement from './pages/SystemManagement';
import AccountManagement from './pages/AccountManagement';
import MarketingNotification from './pages/MarketingNotification';
import { isAuthenticated } from './services/authService';

const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/management/stores"
          element={
            <ProtectedRoute>
              <StoreManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/stores/:storeId"
          element={
            <ProtectedRoute>
              <StoreDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/stores/:storeId/seats"
          element={
            <ProtectedRoute>
              <StoreSeatLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/stores/:storeId/photos"
          element={
            <ProtectedRoute>
              <StorePhotoManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/reports"
          element={
            <ProtectedRoute>
              <ReportManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/customers"
          element={
            <ProtectedRoute>
              <CustomerManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/reservations"
          element={
            <ProtectedRoute>
              <ReservationManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/coupons"
          element={
            <ProtectedRoute>
              <CouponManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/accounts"
          element={
            <ProtectedRoute>
              <AccountManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/systems"
          element={
            <ProtectedRoute>
              <SystemManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/management/notifications/marketing"
          element={
            <ProtectedRoute>
              <MarketingNotification />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
